import { cometFetch } from './cometFetch';
import { REFEREE_ASSIGNMENTS_PATH } from './constants';
import type {
  CometFetchOptions,
  RefereeAssignmentsParams,
  RefereeAssignmentsResponse,
} from './types';

type GetRefereeAssignmentsArgs = CometFetchOptions & {
  params?: RefereeAssignmentsParams;
};

/** Build the query string, omitting empty/undefined params. */
const buildQuery = (params: RefereeAssignmentsParams = {}) => {
  const search = new URLSearchParams();
  (Object.keys(params) as (keyof RefereeAssignmentsParams)[]).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== '') {
      search.set(key, String(value));
    }
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
};

/**
 * GET {base}/referee-assignments?from&to&competitionId&teamId&page&pageSize
 *
 * The search results. Called client-side via the proxy (pass
 * `baseUrl: COMET_PROXY_BASE`); dynamic, so uncached. Returns `null` on failure.
 */
export const getRefereeAssignments = ({
  params,
  baseUrl,
}: GetRefereeAssignmentsArgs = {}) =>
  cometFetch<RefereeAssignmentsResponse>(
    `${REFEREE_ASSIGNMENTS_PATH}${buildQuery(params)}`,
    { baseUrl }
  );
